import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import * as Yup from 'yup';
import * as actions from '../../features/project-on-board/redux/actions';
import { drapcodeIcon, iconForField } from '../../common/custom/icon-library';
export class CreateCollection extends Component {
  static propTypes = {
    projectOnBoard: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    collectionUuid: PropTypes.string,
    projectId: PropTypes.string,
  };
  state = {
    creationFailedMsg: '',
  };

  prepareValidationForFields = () => {
    let validationSchema = {
      collectionTitle: Yup.string()
        .required("Collection Name can't be blank")
        .max(100, 'Name can not be more than 100 characters')
        .matches(/^[A-Za-z\s]+$/, 'Name should not contain special characters or numbers'),
    };
    return Yup.object().shape(validationSchema);
  };

  handleFormSubmit = async (values) => {
    const { projectId, version } = this.props;
    const data = {
      collectionTitle: values.collectionTitle,
      collectionIndex: 1,
      projectId,
      version,
    };
    const createCollectionResponse = await this.props.actions.createCollection(data);
    if (createCollectionResponse && createCollectionResponse.uuid) {
      this.props.changeStatus('');
      this.props.changeProjectStatus({
        state: 'COLLECTION_CREATED',
        status: 'COMPLETE',
        projectId,
        version,
      });
      return;
    } else {
      this.setState({ creationFailedMsg: createCollectionResponse });
    }
  };

  showCreateCollectionForm = () => {
    const { status, creationFailedMsg } = this.state;
    return (
      <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
        <Formik
          initialValues={{ collectionTitle: '' }}
          validationSchema={this.prepareValidationForFields()}
          onSubmit={(values, { setSubmitting, resetForm }) => {
            this.handleFormSubmit(values);
            setSubmitting(false);
            resetForm();
          }}
        >
          {({ isSubmitting, setFieldValue, setFieldTouched, resetForm, errors }) => {
            return (
              <Form className="form-horizontal">
                <div className="row mx-auto">
                  <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                    <div className="form-group">
                      <div className="input-group">
                        <div className="input-group-prepend">
                          <span className="input-group-text">
                            <i className={`wb ${iconForField('text')}`}></i>
                          </span>
                        </div>
                        <Field
                          name="collectionTitle"
                          className="form-control form-control-sm"
                          placeholder="Collection Name"
                          title="Enter Collection Name"
                        />
                        <p className=" text-danger">
                          <ErrorMessage name={'collectionTitle'} />
                        </p>
                      </div>
                    </div>
                  </div>
                  {creationFailedMsg && (
                    <div className="error error-align">{creationFailedMsg}</div>
                  )}
                  <div className="col-md-12 col-lg-12 text-right">
                    <button className="btn btn-theme-submit" type="submit">
                      <i className="wb webconnect-plus"></i> Create
                    </button>
                  </div>
                </div>
              </Form>
            );
          }}
        </Formik>
      </div>
    );
  };

  render() {
    const { status, creationFailedMsg } = this.state;
    return (
      <div className="card">
        <div className="card-header card-header-text" data-background-color="drapcode-violet">
          <h6 className="card-title pb-0 mb-0 text-capitalise">Create Collection</h6>
        </div>

        <div className="card-content">
          <div className="mt-4">{this.showCreateCollectionForm()}</div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    projectOnBoard: state.projectOnBoard,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateCollection);
